var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppartement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1008 55.9602V181.69C76.0708 204.54 90.6608 217.05 119.631 239.9V108.17C90.6608 87.3202 76.0708 76.8102 47.1008 55.9602Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.651 58.8999C201.791 100.9 203.511 140.59 202.651 182.59C174.171 202.04 148.111 220.46 119.631 239.91V108.17C148.961 90.6199 173.321 76.4399 202.651 58.8899V58.8999Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.221 10.0901C113.181 17.7701 100.041 25.4401 86.8008 33.1201C73.5208 40.8201 60.2908 48.4301 47.1108 55.9601C50.9208 58.7001 72.1208 73.9601 75.9308 76.7101C84.1908 82.6601 111.371 102.24 119.641 108.2L202.771 58.9101C172.971 38.9601 156.011 30.0201 126.231 10.0901H126.221Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.241 169.98V147.7L70.731 157.31V180.05L57.241 169.98Z",
    fill: "#A7CFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4309 183.43V161.15L88.9209 170.76V193.5L75.4309 183.43Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6208 197.52V175.24L107.111 184.85V207.59L93.6208 197.52Z",
    fill: "#A7CFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.241 140.03V117.75L70.731 127.36V150.1L57.241 140.03Z",
    fill: "#A7CFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4309 153.48V131.2L88.9209 140.81V163.55L75.4309 153.48Z",
    fill: "#A7CFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6208 167.58V145.3L107.111 154.92V177.66L93.6208 167.59V167.58Z",
    fill: "#A7CFFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.241 110.08V87.8L70.731 97.41V120.15L57.241 110.08Z",
    fill: "#A7CFFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4309 123.53V101.25L88.9209 110.86V133.6L75.4309 123.53Z",
    fill: "#A7CFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6208 137.63V115.35L107.111 124.96V147.7L93.6208 137.63Z",
    fill: "#A7CFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.241 169.98V147.7L70.731 157.31V180.05L57.241 169.98Z",
    fill: "#F97E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6208 197.52V175.24L107.111 184.85V207.59L93.6208 197.52Z",
    fill: "#F97E73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.241 140.03V117.75L70.731 127.36V150.1L57.241 140.03Z",
    fill: "#F97E73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4309 153.48V131.2L88.9209 140.81V163.55L75.4309 153.48Z",
    fill: "#F97E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6208 167.58V145.3L107.111 154.92V177.66L93.6208 167.59V167.58Z",
    fill: "#F97E73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.241 110.08V87.8L70.731 97.41V120.15L57.241 110.08Z",
    fill: "#F97E73"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4309 123.53V101.25L88.9209 110.86V133.6L75.4309 123.53Z",
    fill: "#F97E73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6208 137.63V115.35L107.111 124.96V147.7L93.6208 137.63Z",
    fill: "#F97E73"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.081 203.54V180.69L147.921 170.57V192.89L133.081 203.54Z",
    fill: "#F97E73"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.621 190.14V167.29L167.461 157.17V179.49L152.621 190.14Z",
    fill: "#F97E73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.081 175.24V152.39L147.921 142.27V164.59L133.081 175.24Z",
    fill: "#F97E73"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M152.621 161.78V138.93L167.461 128.81V151.13L152.621 161.78Z",
    fill: "#F97E73"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M133.081 147.07V124.22L147.921 114.1V136.42L133.081 147.07Z",
    fill: "#F97E73"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.621 134.24V111.39L167.461 101.27V123.59L152.621 134.24Z",
    fill: "#F97E73"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.521 176.66V153.81L188.361 143.69V166.01L173.521 176.66Z",
    fill: "#F97E73"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.521 148.3V125.45L188.361 115.33V137.65L173.521 148.3Z",
    fill: "#F97E73"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M173.521 120.77V97.92L188.361 87.8V110.12L173.521 120.77Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppartement);
export default __webpack_public_path__ + "static/media/appartement.1cd0817bd6e6c5d861f63d5ad98d6837.svg";
export { ForwardRef as ReactComponent };